import _ from 'lodash'

import { LoadingContainer, Model, Json } from 'peach/components'
import { useParams } from 'peach/router'

import { Page } from 'core/components'
import { useInternalListCaseTypes } from 'core/types'

const CaseTypes = () => {
  const { companyId } = useParams<{ companyId?: string }>()

  const { data: caseTypes, isLoading } = useInternalListCaseTypes({
    companyId,
  })

  const columns = [
    {
      label: 'Custom Fields',
      render: (item) => {
        const fields = _.map(
          _.sortBy(item.customFieldSchemas, 'displayOrder'),
          (cf) => cf.name,
        )
        return <Json.List compact json={fields} title='Custom Fields' />
      },
    },
  ]

  return (
    <LoadingContainer loading={isLoading}>
      <Page variant='full'>
        <Model.List
          columns={columns}
          json={caseTypes}
          title='Case Types'
          withDetails
          withRelated
          withTimestamps
        />
      </Page>
    </LoadingContainer>
  )
}

export default CaseTypes
